import $ from 'jquery';
import React from 'react';
import { withRouter } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../../constants/server.constant';
import { SessionService } from './../../../services/session.service';
import BmrSlider from './../topRightHeader/bmrSlider';
import { loginService } from '../../../services/login.service';

class TopLeftHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bmrStatusCount: 0,
            bmrList: [],
            isSuspended: localStorage.getItem("status") === 'S',
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
        this.nextPath = this.nextPath.bind(this);
        this.escfunction = this.escfunction.bind(this);
    }

    escfunction(event) {
        if(event.code === 27) {
            $(".bmr_notify_slider").removeClass("active");
            $("body").removeClass("popup_no_scroll");
        }


    }

    toggleUserActiveStatus = () => {
        if(localStorage.getItem("status") !== 'S') {
            this.setState({
                isSuspended: false,
            });
        } else {
            this.setState({
                isSuspended: true,
            });
        }
    };

    nextPath(path) {
        this.props.history.push(path);
    }
    componentDidMount() {
        if(SessionService.getCookie("_bm_count") == "show")
            SessionService.setCookie("_bm_count", "show");

        document.addEventListener("keyup", this.escfunction, false);
        window.addEventListener("storage", this.toggleUserActiveStatus, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
        window.removeEventListener("storage", this.toggleUserActiveStatus, false);
    }

    hamburgerMenuClick() {
        $("main").toggleClass("ls_expand");
    }
    openBmrSlider = () => {
        $('.full_page_loader').css('display', 'block');
        let userId = localStorage.getItem("userId");
        let bmList = [];
        axiosInstance.get(API_HOST + "/baremetal/getbmr/" + userId, axiosRequestWithAuth)
            .then(resp => {
                let res = resp.data;
                console.log(res);
                res.sort(function (a, b) {
                    return new Date(a.bm_requested_on) - new Date(b.bm_requested_on);
                });
                for(let i = 0; i < res.length; i++) {
                    let d = new Date(res[i].bm_requested_on);
                    let createdDate = d.toLocaleString('default', { month: 'short' }) + ' ' + d.getDate() + ',  ' + d.getFullYear() + ' ' + d.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let provisioned = new Date(res[i].provisioned_date);
                    let provisionedDate = provisioned.toLocaleString('default', { month: 'short' }) + ' ' + provisioned.getDate() + ',  ' + provisioned.getFullYear() + ' ' + provisioned.toLocaleString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    });
                    let obj = {
                        "bmrId": res[i].id,
                        "bmrUnits": res[i].bmrUnits,
                        region: {
                            "name": res[i].region.name,
                            "region_id": res[i].region.region_id
                        },
                        flavour: {
                            "flavourId": res[i].flavour.flavour_id,
                            "vcpus": res[i].flavour.vcpus,
                            "disk": res[i].flavour.disk,
                            "ram": res[i].flavour.ram,
                            "monthly_price": res[i].flavour.monthly_price,
                            "processor": res[i].flavour.processor,
                            "disk_type": res[i].flavour.disk_type,
                            "threads": res[i].flavour.threads
                        },

                        "bm_requested_on": createdDate,
                        "bmrStatus": res[i].bmrStatus,
                        "provisionedDate": provisionedDate
                    };
                    bmList.push(obj);
                }
                this.setState({
                    bmrList: bmList
                });
                $(".main_slider").removeClass("active");
                $('.full_page_loader').css('display', 'none');
                $(".bmr_notify_slider").addClass("active");
                $("body").addClass("popup_no_scroll");
                SessionService.setCookie("_bm_count", "hide");
            })
            .catch(error => {
                $('.full_page_loader').css('display', 'none');

            });

    };
    render() {
        return (
            <div className="tn_left">
                <div className="hamburger">
                    <span className="icon_hamburger">
                        <svg className="hamburger_icon" viewBox="0 0 26 26" onClick={ () => this.hamburgerMenuClick() }>
                            <path className="cls-1" d="M5,7H21V9H5Z"></path>
                            <path className="cls-1" d="M5,12H21v2H5Z"></path>
                            <path className="cls-1" d="M5,17H21v2H5Z"></path>
                        </svg>
                    </span>
                </div>
                <div className={ this.state.isSuspended || this.state.isCreateExternalDisabled ? "add_clients_btn tn_btn disabled" : "add_clients_btn tn_btn" }
                    style={ { display: (this.props.showCreate === undefined || this.props.showCreate) && !this.state.isCreateExternalDisabled ? "" : "none" } }
                    onClick={ () => { if(!this.state.isSuspended && !this.state.isCreateExternalDisabled) this.nextPath('/create'); } }
                    data-tip data-for="createInstBtn" aria-describedby='createInstBtn'>
                    <span className="text">Create Instance</span>
                </div>
                <div style={ { display: this.state.isSuspended ? "" : "none" } }>
                    <ReactTooltip id="createInstBtn" place="bottom" effect="solid">Account Suspended. Insufficient privileges to create instance.</ReactTooltip>
                </div>
                <div className="bmr-notify-icon" style={ { display: 'none' } } data-tip data-for="bmrsliderid" aria-describedby="tooltip756661">
                    <span className="icon" onClick={ () => this.openBmrSlider() }>
                        <svg x="0px" y="0px" width="34.02px" height="34.02px" viewBox="0 0 34.02 34.02" enableBackground="new 0 0 34.02 34.02" xmlSpace="preserve">
                            <g>
                                <path fill="#ADADAD" d="M31.69,11.03l-1.71-5.89c-0.09-1.26-1.14-2.26-2.41-2.26H6.45c-1.28,0-2.33,1-2.41,2.26l-1.71,5.89   l-0.3,1.02v16.67c0,1.33,1.09,2.42,2.42,2.42h25.12c1.33,0,2.41-1.09,2.41-2.42V12.04L31.69,11.03z M5.99,5.58L6.03,5.3   c0-0.23,0.19-0.42,0.42-0.42h21.12c0.23,0,0.41,0.19,0.41,0.42l1.63,5.73H4.41L5.99,5.58z M29.98,28.72c0,0.23-0.18,0.42-0.41,0.42   H4.45c-0.23,0-0.42-0.19-0.42-0.42v-6.53h25.95V28.72z M29.98,20.19H4.03v-7.01h25.95V20.19z"></path>
                                <rect x="7.08" y="16.19" fill="#ADADAD" width="9.96" height="1"></rect>
                                <rect x="7.08" y="25.19" fill="#ADADAD" width="9.96" height="1"></rect>
                                <rect x="22.99" y="25.19" fill="#ADADAD" width="2.01" height="1"></rect>
                                <rect x="26.04" y="25.19" fill="#ADADAD" width="2" height="1"></rect>
                                <rect x="22.99" y="16.19" fill="#ADADAD" width="2.01" height="1"></rect>
                                <rect x="26.04" y="16.19" fill="#ADADAD" width="2" height="1"></rect>
                            </g>
                        </svg>
                        <div className="notifyCircle" style={ { display: this.state.bmrStatusCount > 0 && SessionService.getCookie("_bm_count") == "show" ? "" : "none" } }> { this.state.bmrStatusCount } </div>
                    </span>
                </div>

                <ReactTooltip id="bmrsliderid" place="bottom" effect="solid" >Bare Metal Status</ReactTooltip>
                <BmrSlider bmrList={ this.state.bmrList } />
            </div>
        );
    }
}

export default withRouter(TopLeftHeader);